const objeto6 = {
    titulo: `Objetos: Métodos abreviados`,
    problemas: [
        {
            codigo: 1,
            descripcion: `Hay dos sintaxis en JavaScript para definir métodos en un objeto literal:
<code>
const operacion = {
  valor1: 10,
  valor2: 7,
  sumar: function () {
    return this.valor1 + this.valor2;
  },
  restar: function () {
    return this.valor1 - this.valor2;
  }
}

console.log(operacion.sumar())
</pre>
Donde declaramos el nombre de la propiedad (por ejemplo 'sumar'), luego 2 puntos y finalmente la palabra clave function y el algoritmo en si mismo.
La segundo forma más conocisa es la siguiente:
<code>
const operacion = {
  valor1: 10,
  valor2: 7,
  sumar() {
    return this.valor1 + this.valor2;
  },
  restar() {
    return this.valor1 - this.valor2;
  }
}

console.log(operacion.sumar())
</code>
Es decir implementamos el método en el objeto literal.`,
            programa: `const operacion1 = {
  valor1: 10,
  valor2: 7,
  sumar() {
    return this.valor1 + this.valor2;
  },
  restar() {
    return this.valor1 - this.valor2;
  }
}

console.log(operacion1.sumar() - operacion1.restar())`,
            solucion: "14",
        }, {
            codigo: 2,
            descripcion: `Crearemos un objeto literal llamado cliente1 con dos propiedads 'nombre' y 'saldo'. Definiremos tres métodos con notación abreviada que permitan depositar, extraer e imprimir su saldo`,
            programa: `const cliente1 = {
  nombre: 'Juan',
  saldo: 0,
  imprimir() {
    console.log(this.nombre + this.saldo)
  },
  depositar(monto) {
    this.saldo = this.saldo + monto
  },
  extraer(monto) {
    this.saldo = this.saldo - monto
  }
}

cliente1.depositar(1000)
cliente1.extraer(200);
console.log(cliente1.saldo)`,
            solucion: "800",
        }, {
            codigo: 3,
            descripcion: `Algo muy importante con respecto a las funciones flecha de JavaScript es que las funciones flecha no tienen una propiedad 'this'. Por ello, si intentamos acceder a la propiedad 'this' en un objeto literal el resultado no será el que esperamos. Nos retorna el objeto global window en un navegador.`,
            programa: `const operacion = {
  valor1: 10,
  valor2: 7,
  retornarValor1: () => {
      return this.valor1
  }
}

console.log(operacion.retornarValor1()) `,
            solucion: "undefined",
        }
    ]
}

export default objeto6;